module.exports = __webpack_public_path__ + "img/IMG_5894.e4fd60fb.jpg";